<template>
  <div>
    <v-card class="ma-1" max-width="100%">
      <v-row>
        <!-- <v-col cols="5"> -->
        <v-card-title class="primary--text"
          ><v-btn @click="back" class="ml-n7 primary--text" text>
            <v-icon class="ml-3">mdi-reply</v-icon></v-btn
          >Approval
          <span
            style="
              font-style: italic;
              font-family: Times New Roman;
              font-size: 14px;
            "
            class="text-left font-weight: 20 primary--text ml-2"
            >(Mobile Number Change Request)</span
          >
        </v-card-title>

        <!-- </v-col> -->
        <v-spacer></v-spacer>
      </v-row>
      <v-tabs
        v-model="tab"
        background-color="transparent"
        color="primary"
        grow
        active-class="tab1"
      >
        <v-tab v-for="item in tabItems" :key="item" name="item">{{
          item
        }}</v-tab>
      </v-tabs>
    </v-card>

    <PendingMobileNbrRequest
      :tab="tab"
      @GoToHistory="tab = 1"
      v-if="tab == 0"
      @clicked="tabvalue"
    />

    <MobileNbrRequestHistory :tab="tab" v-if="tab == 1" />
  </div>
</template>
<script>
import PendingMobileNbrRequest from "@/components/Apptrail/PendingMobileNbrRequest.vue";

import MobileNbrRequestHistory from "@/components/Apptrail/MobileNbrRequestHistory.vue";

export default {
  components: {
    PendingMobileNbrRequest,
    MobileNbrRequestHistory,
  },
  data: () => ({
    tab: 0,
    tabItems: ["Pending", "History"],
    // tabItems: ["Transactions"],
  }),
  computed: {
    expenserecovercount() {
      return this.$store.getters.get_ExpenseRecoverCount;
    },
  },
  methods: {
    back() {
      this.$router.push("/Dashboard");
    },

    tabvalue() {
      this.tab = 1;
    },
  },
};
</script>
<style>
.tab1 {
  background: linear-gradient(to bottom, #bdbdbd 0%, #bdbdbd 50%, #9e9e9e 100%);
  -webkit-text-fill-color: #2e4152;

  /* box-shadow: 0 0px 5px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23); */
}
</style>
